/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * The fallback when the forced sign-out beats the notice.
 */

import React, { useEffect } from "react";
import { Button } from "@lemonadetraining/web-ui";
import { clearAccessEndedMarker } from "@lemonadetraining/web-shared/utils/accessEndedMarker";

interface Props {
  gymName: string | null;
  onSignIn: () => void;
}

/**
 * Reached only after the server revoked this person's refresh token, which it
 * does when their last tie to a gym is gone. Without this they would land on a
 * bare login screen with no idea why they were signed out.
 */
const AccessEndedScreen: React.FC<Props> = ({ gymName, onSignIn }) => {
  useEffect(() => {
    document.getElementById("access-ended-title")?.focus();
  }, []);

  return (
    <div
      className="mx-auto flex max-w-md flex-col items-start gap-3 px-4 py-16"
      data-testid="access-ended-screen"
    >
      <h1
        id="access-ended-title"
        tabIndex={-1}
        className="text-xl font-semibold text-foreground focus:outline-none"
      >
        {gymName ? `Your access to ${gymName} ended.` : "Your gym access ended."}
      </h1>
      <p className="text-sm text-muted-foreground">
        You&apos;ve been signed out. Sign in again to keep using Lemonade Training.
      </p>
      <Button
        onClick={() => {
          clearAccessEndedMarker();
          onSignIn();
        }}
        data-testid="access-ended-sign-in"
      >
        Sign in
      </Button>
    </div>
  );
};

export default AccessEndedScreen;
